var React = require('react');

function DownloadInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.8 12V15.8H2.2V12H1V17H17V12H15.8ZM14 8.848V7.151L9.6 11.551V1H8.4V11.551L4 7.151V8.848L9 13.849L14 8.848Z","fill":"#000"}));
}

DownloadInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","role":"img","aria-hidden":"true","focusable":"false"};

module.exports = DownloadInline;

DownloadInline.default = DownloadInline;
